// Nord Theme configuration for Mermaid diagrams
export const nordThemeVariables = {
  // Primary colors - Regular action nodes (Polarnacht)
  primaryColor: '#3B4252',
  primaryTextColor: '#ECEFF4',
  primaryBorderColor: '#88C0D0',

  // Secondary colors - Alternative action nodes (slightly different shade)
  secondaryColor: '#434C5E',
  secondaryTextColor: '#E5E9F0',
  secondaryBorderColor: '#81A1C1',

  // Tertiary colors - Special nodes (documentation, etc.)
  tertiaryColor: '#5E81AC',
  tertiaryTextColor: '#ECEFF4',
  tertiaryBorderColor: '#88C0D0',

  // Background
  background: '#2E3440',
  mainBkg: '#3B4252',
  secondBkg: '#434C5E',
  tertiaryBkg: '#4C566A',

  // Text
  textColor: '#ECEFF4',
  labelTextColor: '#ECEFF4',

  // Borders and lines
  border1: '#88C0D0',
  border2: '#81A1C1',
  lineColor: '#88C0D0',

  // Node colors
  nodeBorder: '#88C0D0',
  clusterBkg: '#3B4252',
  clusterBorder: '#88C0D0',
  defaultLinkColor: '#88C0D0',

  // Edge colors
  edgeLabelBackground: '#2E3440',
  edgeLabelText: '#ECEFF4',

  // Special states
  activeColor: '#88C0D0',
  doneColor: '#A3BE8C',
  critColor: '#BF616A',

  // Label styles
  labelBackground: '#2E3440',

  // Fonts
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: '14px',

  // Flowchart specific
  nodeTextColor: '#ECEFF4',
  nodeBkg: '#3B4252',

  // Decision/Diamond nodes (lighter with warm accent for visual hierarchy)
  decisionBkg: '#5E81AC',        // Cooler blue - stands out
  decisionBorder: '#88C0D0',     // Bright frost border
  decisionTextColor: '#ECEFF4',

  // Arrows
  arrowheadColor: '#88C0D0',

  // Grid and axes
  gridColor: '#434C5E',

  // Note colors
  noteBkgColor: '#3B4252',
  noteBorderColor: '#88C0D0',
  noteTextColor: '#ECEFF4'
};

export const nordMermaidConfig = {
  theme: 'base',
  themeVariables: nordThemeVariables,
  flowchart: {
    useMaxWidth: false,
    htmlLabels: true,
    curve: 'basis',
    padding: 30,           // More padding for breathing room
    nodeSpacing: 80,       // More horizontal space between nodes
    rankSpacing: 80,       // More vertical space between rows
    diagramPadding: 20     // Outer padding
  }
};
